import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card, InputAdornment, styled, Badge, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import useDebounce from "../../../libs/hooks/useDebounce";
import SearchData from "../components/SearchData";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
import { PickersDay } from "@mui/lab";
const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 8,
    top: 8,
    padding: '0 4px',
  },
}));
export default function TrainPlanning() {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [sumProcess, setSumProcess] = useState(0);
  const [etdpol, setEtdpol] = useState([]);

  const [checkAll, setCheckAll] = useState(true);
  const [key, setKey] = useState("");
  const debouncedKey = useDebounce(key, 500);
  const [toCountry, setToCountry] = useState('all')
  const [location, setLocation] = useState([])
  const [locationFilter, setLocationFilter] = useState([])
  const [country, setCountry] = useState([]);
  const [toAction, setToAction] = useState('all')
  const SearchDate = (startdate, enddate) => {
    const newData = data.filter((x) => {
      return new Date(x.EtdPol) >= startdate && new Date(x.EtdPol) <= enddate;
    });

    setDataFilter(newData);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer className={gridClasses.toolbarContainer}>
        <GridToolbarExport
          style={{
            color: "#84BD5A",
            borderColor: "#84BD5A",
            border: "1px solid #84BD5A",
          }}
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{
            fields: [
              "Status",
              "Qty",
              "ShipperRefNo",
              "BookingNo",
              "LinersName",
              "PackaegName",
              "CommodityName",
              "PickupFirst",

              "SpDate",
              "EtdCloseingDate",
              "EtdCloseingTime",
            ],
            fileName: "PlanningData " + new Date() + Math.random(),
          }}
        />
      </GridToolbarContainer>
    );
  }

  /* table data */
  const columns = [
    {
      field: "Status",
      headerName: "STATUS",

      width: 120,
      renderCell: ({ value }) => {
        switch (value) {
          case "1":
            return (
              <Chip
                label="New"
                style={{ color: "white", backgroundColor: "#7030a0" }}
              />
            );
          case "2":
            return (
              <Chip
                label="Process"
                style={{ color: "white", backgroundColor: "#ffc000" }}
              />
            );
          case "3":
            return (
              <Chip
                label="Process"
                style={{ color: "white", backgroundColor: "#ffc000" }}
              />
            );
          case "4":
            return (
              <Chip
                label="Process"
                style={{ color: "white", backgroundColor: "#ffc000" }}
              />
            );

          case "5":
            return (
              <Chip
                label="Confirm"
                style={{ color: "white", backgroundColor: "#00c70d" }}
              />
            );
          case "6":
            return (
              <Chip
                label="Process"
                style={{ color: "white", backgroundColor: "#ffc000" }}
              />
            );
          case "7":
            return (
              <Chip
                label="Process"
                style={{ color: "white", backgroundColor: "#ffc000" }}
              />
            );
          case "8":
            return (
              <Chip
                label="Complete"
                style={{ color: "white", backgroundColor: "#00b0f0" }}
              />
            );
          default:
            return (
              <Chip
                label="unidentified"
                style={{ color: "white", backgroundColor: "#FF202B" }}
              />
            );
        }
      },
      // value == 1 ? (
      //   <Chip
      //     label="Complete"
      //     style={{ color: "white", backgroundColor: "#28A745" }}
      //   />
      // ) : (
      //   <Chip
      //     label="Danger"
      //     style={{ color: "white", backgroundColor: "#FF202B" }}
      //   />
      // ),
    },
    { field: "SaleOrderNo", headerName: "Sale Order No.", width: 120 },
    { field: "Qty", headerName: "VOLUME", width: 100 },
    { field: "ShipperRefNo", headerName: "ShipperRefNo", width: 180 },
    { field: "BookingNo", headerName: "BookingNo", width: 180 },
    { field: "LinersName", headerName: "Liners/Friterm", width: 180 },
    { field: "PackageName", headerName: "Package", width: 120 },
    { field: "CommodityName", headerName: "Commodity", width: 120 },
    {
      field: "PickupFirst",
      headerName: "PICK UP DATE",
      width: 150,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "";
      },
    },
    {
      field: "SpDate",
      headerName: "STUFFING",
      width: 120,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "";
      },
    },

    {
      field: "EtdCloseingDate",
      headerName: "CLOSINGDATE",
      width: 120,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "";
      },
    },
    { field: "EtdCloseingTime", headerName: "CLOSING TIME", width: 100 },
    {
      field: "EtdPol",
      headerName: "ETD",
      width: 120,
      valueFormatter: ({ value }) => {
        return value ? moment(value).format("DD-MM-YYYY") : "";
      },
    },
    {
      field: "Action",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/CustomerSupport/EditSaleOrder/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                View
              </Button>
            </Link>
          </>
        );
      },
    },
  ];
  const getStatus = async () => {
    try {
      const data = await api.get(
        `api/planner/container/countstatus?groupId=G002&keyword=${debouncedKey}&POLLocationId=${toAction === 'all' ? '' : toAction}${dateStart ? '&startDate=' + dateStart : ""}${
        dateEnd ? '&endDate=' + dateEnd : ""}`
      );

      setData1(data.data);
      // CalProcess(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  const getEtdpol = async () => {
    try {
      const data = await api.get(
        `api/planner/planning/etdpol?groupId=G002`
      );

      setEtdpol(data.data.map((item) => item.slice(0, 10)));
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Data
  const getData = async () => {
    try {
      const data = await api.get(`api/planner/planning/list?groupId=G002&keyword=${debouncedKey}&POLLocationId=${toAction === 'all' ? '' : toAction}${dateStart ? '&startDate=' + dateStart : ""}${
        dateEnd ? '&endDate=' + dateEnd : ""}`);
      setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  const CalProcess = async (data) => {
    let sum = 0;
    let i = 2;
    for (i = 2; i <= 5; i++) {
      if (data?.find((x) => x.Status === i.toString())) {
        sum = sum + data?.find((x) => x.Status === i.toString())?.Total;
      }
      setSumProcess(sum);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();
    getStatus();
    getEtdpol()
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [debouncedKey, toAction, dateEnd, dateStart]);

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 0,
    left: "auto",
    position: "fixed",
  };
  const getCountry = async () => {
    try {
      const res = await api.get("api/country/list");
      const data = await res.data
      if (res.meta.status === true) {
        setCountry(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data
      if (res.meta.status === true) {
        setLocation(data.filter((x) => x?.Status === true));
        setLocationFilter(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getLocation()
    getCountry()
  }, [])
  useEffect(() => {
    if (toCountry !== 'all') {
      const filterLocation = location?.filter((item) => item.CountryId === toCountry)
      setLocationFilter(filterLocation)
      setToAction(filterLocation[0].LocationId)
    } else {
      setLocationFilter(location)
    }
  }, [toCountry])
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            วางแผน
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Planing
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">Planner</Typography>
              <Typography>
                <span>&nbsp;</span> / Planing
              </Typography>
            </Grid>
          </Grid>

          {/* <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Planner</Typography>
            <Typography>
              <span>&nbsp;</span> / Planing
            </Typography>
          </Grid> */}
          <Grid style={{ flexDirection: "row", padding: "25px" }}>
            {/* <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                borderRadius: "8px",
                border: "10px solid #878787",
                borderColor: "#878787",
                backgroundColor: "#878787",
                marginRight: "30px",
              }}
            >
              Cancel
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {data1?.find((x) => x.Status === "5")?.Total}
              </text>
            </Typography> */}
            <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                border: "10px solid #00b0f0",
                borderRadius: "8px",
                borderColor: "#00b0f0",
                backgroundColor: "#00b0f0",
                marginRight: "30px",
              }}
            >
              Complete
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {data1?.find((x) => x.Status === "Complete")?.Total}
              </text>
            </Typography>
            <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                border: "10px solid #00c70d",
                borderRadius: "8px",
                borderColor: "#00c70d",
                backgroundColor: "#00c70d",
                marginRight: "30px",
              }}
            >
              Confirm
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {data1?.find((x) => x.Status === "Confirm")?.Total}
              </text>
            </Typography>
            {/* <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                border: "10px solid #FF202B",
                borderRadius: "8px",
                borderColor: "#FF202B",
                backgroundColor: "#FF202B",
                marginRight: "30px",
              }}
            >
              Danger
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {data1?.find((x) => x.Status === "2")?.Total}
              </text>
            </Typography> */}
            <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                border: "10px solid #ffc000",
                borderRadius: "8px",
                borderColor: "#ffc000",
                backgroundColor: "#ffc000",
                marginRight: "30px",
              }}
            >
              Process
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {
                  data1?.find((x) => x.Status === "Process")?.Total
                  // sumProcess
                }
              </text>
            </Typography>
            <Typography
              variant="contained"
              style={{
                color: "#FFFFFFFF",
                textTransform: "none",
                border: "10px solid #7030a0",
                borderColor: "#7030a0",
                borderRadius: "8px",
                backgroundColor: "#7030a0",
                marginRight: "30px",
              }}
            >
              New
              <text
                style={{
                  backgroundColor: "white",
                  color: "black",

                  borderRadius: "2px",
                  marginLeft: "12px",
                  paddingLeft: "8px",

                  paddingRight: "8px",
                }}
              >
                {data1?.find((x) => x.Status === "New")?.Total}
              </text>
            </Typography>
          </Grid>
          <Grid
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
            }}
            spacing={1}
          >
            <div style={{ display: "flex" }}>
           
              <FormControl size="small" sx={{
                width: "15%", marginRight: '10px',
              }}>
                <InputLabel>Country</InputLabel>
                <Select
                  label="Country"
                  value={toCountry}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setToCountry(e.target.value)
                  }}
                // disabled={values.liners !== ""}
                >
                  <MenuItem
                    value={"all"}
                  >
                    ทั้งหมด
                  </MenuItem>
                  {country?.map((x) => (
                    <MenuItem
                      value={x?.CountryId}
                    >
                      {x?.CountryName}
                    </MenuItem>
                  ))}


                </Select>
              </FormControl>

              <FormControl size="small" sx={{
                width: "15%", marginRight: '10px',
              }}>
                <InputLabel>Location</InputLabel>
                <Select
                  label="Location"
                  value={toAction || ''}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {

                    setToAction(e.target.value)
                  }}
                // disabled={values.liners !== ""}
                >
                  <MenuItem
                    value={"all"}
                  >
                    ทั้งหมด
                  </MenuItem>
                  {locationFilter?.map((x) => (
                    <MenuItem
                      value={x?.LocationId}
                    >
                      {x?.LocationName}
                    </MenuItem>
                  ))}


                </Select>
              </FormControl>
              <DesktopDatePicker
                label="dateStart"
                inputFormat="yyyy/MM/dd"
                value={dateStart}
                minDate={new Date("2017-01-01")}
                onChange={async (newValue) => {
                  setDateStart(newValue);
                  setCheckAll(false);
                  await SearchDate(newValue, dateEnd);
                }}
                renderDay={(day, selectedDate, pickersDayProps) => {
                  const isSunny = etdpol?.includes(day.toISOString().slice(0, 10));

                  return (
                    <StyledBadge sx={{ color: 'red' }} badgeContent={isSunny && !pickersDayProps.outsideCurrentMonth ? <div style={{ width: "10px", height: "10px", background: "red", borderRadius: "50%" }}></div> : undefined}>
                      <PickersDay

                        {...pickersDayProps}
                      />
                    </StyledBadge>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    style={{ width: "25%" }} {...params} />
                )}
              />
              <DesktopDatePicker
                label="dateEnd"
                inputFormat="yyyy/MM/dd"
                value={dateEnd}
                minDate={new Date(dateStart)}
                onChange={async (newValue) => {
                  setDateEnd(newValue);
                  setCheckAll(false);
                  await SearchDate(dateStart, newValue);
                }}
                renderDay={(day, selectedDate, pickersDayProps) => {
                  const isSunny = etdpol?.includes(day.toISOString().slice(0, 10));

                  return (
                    <StyledBadge sx={{ color: 'red' }} badgeContent={isSunny && !pickersDayProps.outsideCurrentMonth ? <div style={{ width: "10px", height: "10px", background: "red", borderRadius: "50%" }}></div> : undefined}>
                      <PickersDay

                        {...pickersDayProps}
                      />
                    </StyledBadge>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    style={{ width: "25%", marginLeft: "10px", marginRight: '10px' }}
                    {...params}
                  />
                )}
              />

              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                }}
                label="Search"
                onChange={(e) => setKey(e.target.value)}
                size="small"
              />
            </div>
          </Grid>
          <FormControlLabel
            control={
              <Checkbox
                checked={checkAll}
                onClick={() => {
                  setCheckAll(!checkAll);
                  getData();
                }}
              />
            }
            label="ดูข้อมูลทั้งหมด"
          />

          <Box
            sx={{
              height: 630,
              width: "100%",
              marginTop: "10px",
              "& .Active": {
                color: "#28A745",
              },
              "& .Inactive": {
                color: "#F53C56",
              },
              '& .MuiDataGrid-cell--withRenderer': {
                width: '100%',
                backgroundColor: "#fff",
                position: "sticky",
                right: '0'
              }
            }}
          >
            <DataGrid
              getRowId={(r) => r.SoId}
              rows={dataFilter}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              hideFooterSelectedRowCount
              disableColumnFilter
              disableColumnMenu
              getCellClassName={(params) => {
                if (params.field === "Status") {
                  return params.value == 1 ? "Active" : "Inactive";
                }
              }}
              components={{
                Toolbar: CustomToolbar,
              }}
            />
          </Box>
        </Card>
      </LocalizationProvider>
    </div>
  );
}
